/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createListing = /* GraphQL */ `
  mutation CreateListing(
    $input: CreateListingInput!
    $condition: ModelListingConditionInput
  ) {
    createListing(input: $input, condition: $condition) {
      id
      userId
      gen_title
      gen_desc
      timezone
      gen_captainOnboard
      operator
      gen_type
      status
      spec_makeModel
      spec_length
      spec_year
      spec_capacity
      spec_numberEngines
      spec_horsepower
      spec_engineBrand
      spec_engineModel
      feature_BBQ
      feature_bimini
      feature_cabin
      feature_cuddyCabin
      feature_dinghy
      feature_dualForwardSeating
      feature_fishingGear
      feature_fuelTypeDiesel
      feature_galleyStoveOven
      feature_inverter
      feature_licensingRequired
      feature_singleEngine
      feature_toilet
      feature_watersportsEquipment
      feature_wiFi
      price_currency
      price_autobook
      price_1duration
      price_1
      price_1premium
      price_2duration
      price_2
      price_2premium
      price_3duration
      price_3
      price_3premium
      price_4duration
      price_4
      price_4premium
      price_5duration
      price_5
      price_5premium
      cancelDays
      cancelRefund
      detailsRules
      detailsToBring
      detailsDeparture
      location_address
      location {
        lat
        lon
        __typename
      }
      location_vicinity
      sort
      createdAt
      updatedAt
      photos {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateListing = /* GraphQL */ `
  mutation UpdateListing(
    $input: UpdateListingInput!
    $condition: ModelListingConditionInput
  ) {
    updateListing(input: $input, condition: $condition) {
      id
      userId
      gen_title
      gen_desc
      timezone
      gen_captainOnboard
      operator
      gen_type
      status
      spec_makeModel
      spec_length
      spec_year
      spec_capacity
      spec_numberEngines
      spec_horsepower
      spec_engineBrand
      spec_engineModel
      feature_BBQ
      feature_bimini
      feature_cabin
      feature_cuddyCabin
      feature_dinghy
      feature_dualForwardSeating
      feature_fishingGear
      feature_fuelTypeDiesel
      feature_galleyStoveOven
      feature_inverter
      feature_licensingRequired
      feature_singleEngine
      feature_toilet
      feature_watersportsEquipment
      feature_wiFi
      price_currency
      price_autobook
      price_1duration
      price_1
      price_1premium
      price_2duration
      price_2
      price_2premium
      price_3duration
      price_3
      price_3premium
      price_4duration
      price_4
      price_4premium
      price_5duration
      price_5
      price_5premium
      cancelDays
      cancelRefund
      detailsRules
      detailsToBring
      detailsDeparture
      location_address
      location {
        lat
        lon
        __typename
      }
      location_vicinity
      sort
      createdAt
      updatedAt
      photos {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteListing = /* GraphQL */ `
  mutation DeleteListing(
    $input: DeleteListingInput!
    $condition: ModelListingConditionInput
  ) {
    deleteListing(input: $input, condition: $condition) {
      id
      userId
      gen_title
      gen_desc
      timezone
      gen_captainOnboard
      operator
      gen_type
      status
      spec_makeModel
      spec_length
      spec_year
      spec_capacity
      spec_numberEngines
      spec_horsepower
      spec_engineBrand
      spec_engineModel
      feature_BBQ
      feature_bimini
      feature_cabin
      feature_cuddyCabin
      feature_dinghy
      feature_dualForwardSeating
      feature_fishingGear
      feature_fuelTypeDiesel
      feature_galleyStoveOven
      feature_inverter
      feature_licensingRequired
      feature_singleEngine
      feature_toilet
      feature_watersportsEquipment
      feature_wiFi
      price_currency
      price_autobook
      price_1duration
      price_1
      price_1premium
      price_2duration
      price_2
      price_2premium
      price_3duration
      price_3
      price_3premium
      price_4duration
      price_4
      price_4premium
      price_5duration
      price_5
      price_5premium
      cancelDays
      cancelRefund
      detailsRules
      detailsToBring
      detailsDeparture
      location_address
      location {
        lat
        lon
        __typename
      }
      location_vicinity
      sort
      createdAt
      updatedAt
      photos {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createPhoto = /* GraphQL */ `
  mutation CreatePhoto(
    $input: CreatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    createPhoto(input: $input, condition: $condition) {
      id
      listingCover
      listingId
      userId
      fileType
      photoType
      size
      height
      width
      sort
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePhoto = /* GraphQL */ `
  mutation UpdatePhoto(
    $input: UpdatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    updatePhoto(input: $input, condition: $condition) {
      id
      listingCover
      listingId
      userId
      fileType
      photoType
      size
      height
      width
      sort
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePhoto = /* GraphQL */ `
  mutation DeletePhoto(
    $input: DeletePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    deletePhoto(input: $input, condition: $condition) {
      id
      listingCover
      listingId
      userId
      fileType
      photoType
      size
      height
      width
      sort
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createContactUs = /* GraphQL */ `
  mutation CreateContactUs(
    $input: CreateContactUsInput!
    $condition: ModelContactUsConditionInput
  ) {
    createContactUs(input: $input, condition: $condition) {
      id
      owner
      name
      email
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateContactUs = /* GraphQL */ `
  mutation UpdateContactUs(
    $input: UpdateContactUsInput!
    $condition: ModelContactUsConditionInput
  ) {
    updateContactUs(input: $input, condition: $condition) {
      id
      owner
      name
      email
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteContactUs = /* GraphQL */ `
  mutation DeleteContactUs(
    $input: DeleteContactUsInput!
    $condition: ModelContactUsConditionInput
  ) {
    deleteContactUs(input: $input, condition: $condition) {
      id
      owner
      name
      email
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBooking = /* GraphQL */ `
  mutation CreateBooking(
    $input: CreateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    createBooking(input: $input, condition: $condition) {
      id
      owner
      listingId
      hostId
      priceOption
      price
      duration
      priceOptionPremium
      pricePremium
      fees
      durationPremium
      hostDiscount
      currency
      adults
      children
      message
      timezone
      notify
      chatBlocked
      departurePrimary
      departurePrimaryPremium
      departureSecondary
      departureSecondaryPremium
      departureHost
      acceptedAtHost
      acceptedAtGuest
      paymentInfo
      paymentCreateAt
      paymentCreate
      paymentIntentStripe
      paymentSuccess
      verifySubmit
      secretCode
      secretCodeSubmit
      secretCodeSubmitAt
      secretCodeSuccess
      cancelAtHost
      declineAtHost
      declineAtGuest
      hostPayoutId
      seenGuest
      seenHost
      createdAt
      updatedAt
      listing {
        id
        userId
        gen_title
        gen_desc
        timezone
        gen_captainOnboard
        operator
        gen_type
        status
        spec_makeModel
        spec_length
        spec_year
        spec_capacity
        spec_numberEngines
        spec_horsepower
        spec_engineBrand
        spec_engineModel
        feature_BBQ
        feature_bimini
        feature_cabin
        feature_cuddyCabin
        feature_dinghy
        feature_dualForwardSeating
        feature_fishingGear
        feature_fuelTypeDiesel
        feature_galleyStoveOven
        feature_inverter
        feature_licensingRequired
        feature_singleEngine
        feature_toilet
        feature_watersportsEquipment
        feature_wiFi
        price_currency
        price_autobook
        price_1duration
        price_1
        price_1premium
        price_2duration
        price_2
        price_2premium
        price_3duration
        price_3
        price_3premium
        price_4duration
        price_4
        price_4premium
        price_5duration
        price_5
        price_5premium
        cancelDays
        cancelRefund
        detailsRules
        detailsToBring
        detailsDeparture
        location_address
        location_vicinity
        sort
        createdAt
        updatedAt
        __typename
      }
      guestUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      hostUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      chat {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateBooking = /* GraphQL */ `
  mutation UpdateBooking(
    $input: UpdateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    updateBooking(input: $input, condition: $condition) {
      id
      owner
      listingId
      hostId
      priceOption
      price
      duration
      priceOptionPremium
      pricePremium
      fees
      durationPremium
      hostDiscount
      currency
      adults
      children
      message
      timezone
      notify
      chatBlocked
      departurePrimary
      departurePrimaryPremium
      departureSecondary
      departureSecondaryPremium
      departureHost
      acceptedAtHost
      acceptedAtGuest
      paymentInfo
      paymentCreateAt
      paymentCreate
      paymentIntentStripe
      paymentSuccess
      verifySubmit
      secretCode
      secretCodeSubmit
      secretCodeSubmitAt
      secretCodeSuccess
      cancelAtHost
      declineAtHost
      declineAtGuest
      hostPayoutId
      seenGuest
      seenHost
      createdAt
      updatedAt
      listing {
        id
        userId
        gen_title
        gen_desc
        timezone
        gen_captainOnboard
        operator
        gen_type
        status
        spec_makeModel
        spec_length
        spec_year
        spec_capacity
        spec_numberEngines
        spec_horsepower
        spec_engineBrand
        spec_engineModel
        feature_BBQ
        feature_bimini
        feature_cabin
        feature_cuddyCabin
        feature_dinghy
        feature_dualForwardSeating
        feature_fishingGear
        feature_fuelTypeDiesel
        feature_galleyStoveOven
        feature_inverter
        feature_licensingRequired
        feature_singleEngine
        feature_toilet
        feature_watersportsEquipment
        feature_wiFi
        price_currency
        price_autobook
        price_1duration
        price_1
        price_1premium
        price_2duration
        price_2
        price_2premium
        price_3duration
        price_3
        price_3premium
        price_4duration
        price_4
        price_4premium
        price_5duration
        price_5
        price_5premium
        cancelDays
        cancelRefund
        detailsRules
        detailsToBring
        detailsDeparture
        location_address
        location_vicinity
        sort
        createdAt
        updatedAt
        __typename
      }
      guestUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      hostUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      chat {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteBooking = /* GraphQL */ `
  mutation DeleteBooking(
    $input: DeleteBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    deleteBooking(input: $input, condition: $condition) {
      id
      owner
      listingId
      hostId
      priceOption
      price
      duration
      priceOptionPremium
      pricePremium
      fees
      durationPremium
      hostDiscount
      currency
      adults
      children
      message
      timezone
      notify
      chatBlocked
      departurePrimary
      departurePrimaryPremium
      departureSecondary
      departureSecondaryPremium
      departureHost
      acceptedAtHost
      acceptedAtGuest
      paymentInfo
      paymentCreateAt
      paymentCreate
      paymentIntentStripe
      paymentSuccess
      verifySubmit
      secretCode
      secretCodeSubmit
      secretCodeSubmitAt
      secretCodeSuccess
      cancelAtHost
      declineAtHost
      declineAtGuest
      hostPayoutId
      seenGuest
      seenHost
      createdAt
      updatedAt
      listing {
        id
        userId
        gen_title
        gen_desc
        timezone
        gen_captainOnboard
        operator
        gen_type
        status
        spec_makeModel
        spec_length
        spec_year
        spec_capacity
        spec_numberEngines
        spec_horsepower
        spec_engineBrand
        spec_engineModel
        feature_BBQ
        feature_bimini
        feature_cabin
        feature_cuddyCabin
        feature_dinghy
        feature_dualForwardSeating
        feature_fishingGear
        feature_fuelTypeDiesel
        feature_galleyStoveOven
        feature_inverter
        feature_licensingRequired
        feature_singleEngine
        feature_toilet
        feature_watersportsEquipment
        feature_wiFi
        price_currency
        price_autobook
        price_1duration
        price_1
        price_1premium
        price_2duration
        price_2
        price_2premium
        price_3duration
        price_3
        price_3premium
        price_4duration
        price_4
        price_4premium
        price_5duration
        price_5
        price_5premium
        cancelDays
        cancelRefund
        detailsRules
        detailsToBring
        detailsDeparture
        location_address
        location_vicinity
        sort
        createdAt
        updatedAt
        __typename
      }
      guestUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      hostUser {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      chat {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserData = /* GraphQL */ `
  mutation DeleteUserData(
    $input: DeleteUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    deleteUserData(input: $input, condition: $condition) {
      id
      firstName
      currency
      about
      languages
      timezone
      tracking
      termsAccept
      photoPrimary
      primaryType
      newsletter
      emailOptOut
      phone
      email
      location_lat
      location_lng
      pushToken
      payoutAddress
      payoutCurrency
      payoutAccount
      payoutName
      payoutBankCode
      payoutBranchCode
      stripeConnect
      stripeConnectPK
      createdAt
      updatedAt
      listings {
        total
        nextToken
        __typename
      }
      photos {
        nextToken
        __typename
      }
      guestBookings {
        nextToken
        __typename
      }
      lastName
      reviews {
        nextToken
        __typename
      }
      payouts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserData = /* GraphQL */ `
  mutation CreateUserData(
    $input: CreateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    createUserData(input: $input, condition: $condition) {
      id
      firstName
      currency
      about
      languages
      timezone
      tracking
      termsAccept
      photoPrimary
      primaryType
      newsletter
      emailOptOut
      phone
      email
      location_lat
      location_lng
      pushToken
      payoutAddress
      payoutCurrency
      payoutAccount
      payoutName
      payoutBankCode
      payoutBranchCode
      stripeConnect
      stripeConnectPK
      createdAt
      updatedAt
      listings {
        total
        nextToken
        __typename
      }
      photos {
        nextToken
        __typename
      }
      guestBookings {
        nextToken
        __typename
      }
      lastName
      reviews {
        nextToken
        __typename
      }
      payouts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUserData = /* GraphQL */ `
  mutation UpdateUserData(
    $input: UpdateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    updateUserData(input: $input, condition: $condition) {
      id
      firstName
      currency
      about
      languages
      timezone
      tracking
      termsAccept
      photoPrimary
      primaryType
      newsletter
      emailOptOut
      phone
      email
      location_lat
      location_lng
      pushToken
      payoutAddress
      payoutCurrency
      payoutAccount
      payoutName
      payoutBankCode
      payoutBranchCode
      stripeConnect
      stripeConnectPK
      createdAt
      updatedAt
      listings {
        total
        nextToken
        __typename
      }
      photos {
        nextToken
        __typename
      }
      guestBookings {
        nextToken
        __typename
      }
      lastName
      reviews {
        nextToken
        __typename
      }
      payouts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      listingId
      bookingId
      userId
      userType
      rating
      desc
      visible
      createdAt
      updatedAt
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      owner
      __typename
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      listingId
      bookingId
      userId
      userType
      rating
      desc
      visible
      createdAt
      updatedAt
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      owner
      __typename
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      listingId
      bookingId
      userId
      userType
      rating
      desc
      visible
      createdAt
      updatedAt
      user {
        id
        firstName
        currency
        about
        languages
        timezone
        tracking
        termsAccept
        photoPrimary
        primaryType
        newsletter
        emailOptOut
        phone
        email
        location_lat
        location_lng
        pushToken
        payoutAddress
        payoutCurrency
        payoutAccount
        payoutName
        payoutBankCode
        payoutBranchCode
        stripeConnect
        stripeConnectPK
        createdAt
        updatedAt
        lastName
        __typename
      }
      owner
      __typename
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      bookingId
      hostId
      payoutId
      amount
      feeHostAmount
      feeHostPercent
      feeGuestAmount
      feeGuestPercent
      name
      cardLast4
      cardType
      expiration
      address1
      address2
      city
      province
      postal
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      bookingId
      hostId
      payoutId
      amount
      feeHostAmount
      feeHostPercent
      feeGuestAmount
      feeGuestPercent
      name
      cardLast4
      cardType
      expiration
      address1
      address2
      city
      province
      postal
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      bookingId
      hostId
      payoutId
      amount
      feeHostAmount
      feeHostPercent
      feeGuestAmount
      feeGuestPercent
      name
      cardLast4
      cardType
      expiration
      address1
      address2
      city
      province
      postal
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHostPayout = /* GraphQL */ `
  mutation CreateHostPayout(
    $input: CreateHostPayoutInput!
    $condition: ModelHostPayoutConditionInput
  ) {
    createHostPayout(input: $input, condition: $condition) {
      id
      userId
      status
      targetPayoutDate
      createdAt
      updatedAt
      payments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateHostPayout = /* GraphQL */ `
  mutation UpdateHostPayout(
    $input: UpdateHostPayoutInput!
    $condition: ModelHostPayoutConditionInput
  ) {
    updateHostPayout(input: $input, condition: $condition) {
      id
      userId
      status
      targetPayoutDate
      createdAt
      updatedAt
      payments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteHostPayout = /* GraphQL */ `
  mutation DeleteHostPayout(
    $input: DeleteHostPayoutInput!
    $condition: ModelHostPayoutConditionInput
  ) {
    deleteHostPayout(input: $input, condition: $condition) {
      id
      userId
      status
      targetPayoutDate
      createdAt
      updatedAt
      payments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createChat = /* GraphQL */ `
  mutation CreateChat(
    $input: CreateChatInput!
    $condition: ModelChatConditionInput
  ) {
    createChat(input: $input, condition: $condition) {
      id
      from
      fromName
      to
      toSeen
      message
      createdAt
      notify
      blocked
      updatedAt
      __typename
    }
  }
`;
export const updateChat = /* GraphQL */ `
  mutation UpdateChat(
    $input: UpdateChatInput!
    $condition: ModelChatConditionInput
  ) {
    updateChat(input: $input, condition: $condition) {
      id
      from
      fromName
      to
      toSeen
      message
      createdAt
      notify
      blocked
      updatedAt
      __typename
    }
  }
`;
export const deleteChat = /* GraphQL */ `
  mutation DeleteChat(
    $input: DeleteChatInput!
    $condition: ModelChatConditionInput
  ) {
    deleteChat(input: $input, condition: $condition) {
      id
      from
      fromName
      to
      toSeen
      message
      createdAt
      notify
      blocked
      updatedAt
      __typename
    }
  }
`;
export const createEmailTemplate = /* GraphQL */ `
  mutation CreateEmailTemplate(
    $input: CreateEmailTemplateInput!
    $condition: ModelEmailTemplateConditionInput
  ) {
    createEmailTemplate(input: $input, condition: $condition) {
      id
      name
      subject
      html
      template
      published
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEmailTemplate = /* GraphQL */ `
  mutation UpdateEmailTemplate(
    $input: UpdateEmailTemplateInput!
    $condition: ModelEmailTemplateConditionInput
  ) {
    updateEmailTemplate(input: $input, condition: $condition) {
      id
      name
      subject
      html
      template
      published
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEmailTemplate = /* GraphQL */ `
  mutation DeleteEmailTemplate(
    $input: DeleteEmailTemplateInput!
    $condition: ModelEmailTemplateConditionInput
  ) {
    deleteEmailTemplate(input: $input, condition: $condition) {
      id
      name
      subject
      html
      template
      published
      createdAt
      updatedAt
      __typename
    }
  }
`;
